import { render, staticRenderFns } from "./UserSettingsDisplay.vue?vue&type=template&id=69c834cb&scoped=true&"
import script from "./UserSettingsDisplay.vue?vue&type=script&lang=ts&"
export * from "./UserSettingsDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c834cb",
  null
  
)

export default component.exports